(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["setup-fit-advisor"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('setup-fit-advisor')) {
    customElements.define(
      'setup-fit-advisor',
      class SetupFitAdvisor extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready === 'true') return;
          this.dataset.ready = 'true';
          this.form = this.querySelector('[data-fit-measurement-form]');
          this.result = this.querySelector('[data-fit-result]');
          this.status = this.querySelector('[data-fit-result-status]');
          this.resultTitle = this.querySelector('[data-fit-result-title]');
          this.copy = this.querySelector('[data-fit-result-copy]');
          this.measurements = this.querySelector('[data-fit-result-measurements]');
          this.unit = this.querySelector('[data-fit-unit]');
          this.pendingApply = null;
          this.form?.addEventListener('submit', (event) => this.evaluate(event));
          this.unit?.addEventListener('change', () => this.syncUnitLabels());
          this.querySelectorAll('[data-fit-apply-form]').forEach((form) => {
            form.addEventListener('submit', (event) => this.applyChoice(event));
          });
          this.syncUnitLabels();
        }

        syncUnitLabels() {
          const unit = this.unit?.value === 'in' ? this.dataset.copyUnitIn : this.dataset.copyUnitCm;
          this.querySelectorAll('[data-fit-unit-label]').forEach((label) => {
            label.textContent = unit;
          });
        }

        number(name) {
          const input = this.querySelector(`[data-fit-input="${name}"]`);
          return input instanceof HTMLInputElement ? input.valueAsNumber : Number.NaN;
        }

        toCentimetres(value) {
          return this.unit?.value === 'in' ? value * 2.54 : value;
        }

        fromCentimetres(value) {
          return this.unit?.value === 'in' ? value / 2.54 : value;
        }

        format(value) {
          return new Intl.NumberFormat(document.documentElement.lang || 'en', {
            maximumFractionDigits: 2
          }).format(value);
        }

        hideChoices() {
          this.querySelectorAll('[data-fit-apply-form]').forEach((form) => {
            form.hidden = true;
          });
        }

        showChoice(kind) {
          const form = this.querySelector(`[data-fit-apply-form][data-choice-kind="${kind}"]`);
          if (form?.dataset.choiceAvailable === 'true') form.hidden = false;
          return form?.dataset.choiceAvailable === 'true';
        }

        showResult(status, title, copy, measurementCopy = '') {
          this.status.textContent = status;
          this.resultTitle.textContent = title;
          this.copy.textContent = copy;
          this.measurements.textContent = measurementCopy;
          this.result.hidden = false;
          this.result.focus({ preventScroll: true });
        }

        evaluate(event) {
          event.preventDefault();
          if (!this.form?.reportValidity()) return;
          this.hideChoices();
          if (this.dataset.advisorType === 'mat') {
            this.evaluateMat();
          } else {
            this.evaluateTray();
          }
        }

        evaluateMat() {
          const values = {
            workWidth: this.number('work-width'),
            workDepth: this.number('work-depth'),
            clearWidth: this.number('clear-width'),
            clearDepth: this.number('clear-depth')
          };
          if (Object.values(values).some((value) => !Number.isFinite(value) || value <= 0)) return;
          const measured = Object.fromEntries(
            Object.entries(values).map(([key, value]) => [key, this.toCentimetres(value)])
          );
          const tolerance = 0.0001;
          const unit = this.unit?.value === 'in' ? this.dataset.copyUnitIn : this.dataset.copyUnitCm;
          const inputSummary = `${this.dataset.copyMeasurements}: ${this.format(values.workWidth)} × ${this.format(
            values.workDepth
          )} ${unit}; ${this.format(values.clearWidth)} × ${this.format(values.clearDepth)} ${unit}.`;

          if (
            measured.workWidth > measured.clearWidth + tolerance ||
            measured.workDepth > measured.clearDepth + tolerance
          ) {
            this.showResult(
              this.dataset.copyMatConflict,
              this.dataset.copyMatConflict,
              this.dataset.copyMatConflict,
              inputSummary
            );
            this.publish('completed', 'measurement_conflict', values);
            return;
          }

          const choices = Array.from(this.querySelectorAll('[data-choice-kind="mat"]'))
            .map((form) => ({
              form,
              width: Number.parseFloat(form.dataset.choiceWidth || ''),
              depth: Number.parseFloat(form.dataset.choiceDepth || ''),
              available: form.dataset.choiceAvailable === 'true'
            }))
            .filter((choice) => Number.isFinite(choice.width) && Number.isFinite(choice.depth))
            .sort((a, b) => {
              const areaDifference = a.width * a.depth - b.width * b.depth;
              if (areaDifference !== 0) return areaDifference;
              const surplusA = a.width - measured.workWidth + (a.depth - measured.workDepth);
              const surplusB = b.width - measured.workWidth + (b.depth - measured.workDepth);
              if (surplusA !== surplusB) return surplusA - surplusB;
              if (a.width !== b.width) return a.width - b.width;
              return a.depth - b.depth;
            });
          const deskFits = choices.filter(
            (choice) =>
              choice.width <= measured.clearWidth + tolerance && choice.depth <= measured.clearDepth + tolerance
          );
          const dimensionalMatches = deskFits.filter(
            (choice) =>
              choice.width + tolerance >= measured.workWidth && choice.depth + tolerance >= measured.workDepth
          );
          const match = dimensionalMatches.find((choice) => choice.available);

          if (deskFits.length === 0) {
            this.showResult(
              this.dataset.copyMatNoDesk,
              this.dataset.copyMatNoDesk,
              this.dataset.copyMatNoDesk,
              inputSummary
            );
            this.publish('completed', 'no_desk_match', values);
            return;
          }
          if (dimensionalMatches.length === 0) {
            this.showResult(
              this.dataset.copyMatNoCover,
              this.dataset.copyMatNoCover,
              this.dataset.copyMatNoCover,
              inputSummary
            );
            this.publish('completed', 'no_work_area_match', values);
            return;
          }
          if (!match) {
            this.showResult(
              this.dataset.copyMatNoStock,
              this.dataset.copyMatNoStock,
              this.dataset.copyMatNoStock,
              inputSummary
            );
            this.publish('completed', 'no_available_match', values);
            return;
          }

          match.form.hidden = false;
          const choiceLabel =
            match.form.querySelector('[data-fit-choice-label]')?.dataset.fitChoiceLabel ||
            `${match.width} × ${match.depth} cm`;
          const workAllowanceWidth = this.fromCentimetres(match.width - measured.workWidth);
          const workAllowanceDepth = this.fromCentimetres(match.depth - measured.workDepth);
          const clearAllowanceWidth = this.fromCentimetres(measured.clearWidth - match.width);
          const clearAllowanceDepth = this.fromCentimetres(measured.clearDepth - match.depth);
          const exact =
            Math.abs(workAllowanceWidth) < 0.0001 ||
            Math.abs(workAllowanceDepth) < 0.0001 ||
            Math.abs(clearAllowanceWidth) < 0.0001 ||
            Math.abs(clearAllowanceDepth) < 0.0001;
          const allowance = `${this.dataset.copyMatAllowance}: ${this.format(workAllowanceWidth)} × ${this.format(
            workAllowanceDepth
          )} ${unit}; ${this.format(clearAllowanceWidth)} × ${this.format(clearAllowanceDepth)} ${unit}.`;
          const copy = [
            this.dataset.copyMatMatchCopy,
            exact ? this.dataset.copyMatExact : '',
            dimensionalMatches[0] !== match ? this.dataset.copyMatNextAvailable : '',
            this.dataset.copyMatTape
          ]
            .filter(Boolean)
            .join(' ');
          this.showResult(this.dataset.copyMatMatch, choiceLabel, copy, allowance);
          this.publish('completed', 'match', { ...values, recommended_variant: choiceLabel });
        }

        evaluateTray() {
          const thicknessInput = this.number('thickness');
          const spanInput = this.number('span');
          if (!Number.isFinite(thicknessInput) || !Number.isFinite(spanInput)) return;
          const thickness = this.toCentimetres(thicknessInput);
          const span = this.toCentimetres(spanInput);
          const model = this.querySelector('[data-fit-input="model"]')?.value || 'compare';
          const mount = this.querySelector('[data-fit-input="mount"]')?.value || 'unsure';
          const unit = this.unit?.value === 'in' ? this.dataset.copyUnitIn : this.dataset.copyUnitCm;
          const tolerance = 0.0001;
          const inputSummary = `${this.dataset.copyMeasurements}: ${this.format(thicknessInput)} ${unit}; ${this.format(
            spanInput
          )} ${unit}.`;
          const boundary =
            Math.abs(thickness - 2) < tolerance ||
            Math.abs(thickness - 4.5) < tolerance ||
            (model !== 'retractable' && Math.abs(span - 40) < tolerance) ||
            (model !== 'fixed' && (Math.abs(span - 43) < tolerance || Math.abs(span - 74) < tolerance));

          if (thickness < 2 - tolerance) {
            this.showResult(
              this.dataset.copyTrayMismatch,
              this.dataset.copyTrayMismatch,
              this.dataset.copyTrayThin,
              inputSummary
            );
            this.publish('completed', 'clamp_too_thin', { thickness: thicknessInput, span: spanInput, model, mount });
            return;
          }
          if (thickness > 4.5 + tolerance) {
            this.showResult(
              this.dataset.copyTrayMismatch,
              this.dataset.copyTrayMismatch,
              this.dataset.copyTrayThick,
              inputSummary
            );
            this.publish('completed', 'clamp_too_thick', { thickness: thicknessInput, span: spanInput, model, mount });
            return;
          }

          const fixedEligible = span >= 40 - tolerance;
          const retractableEligible = span >= 43 - tolerance;
          if ((model === 'fixed' && !fixedEligible) || (model === 'retractable' && !retractableEligible)) {
            const copy =
              model === 'fixed' ? this.dataset.copyTrayFixedShort : this.dataset.copyTrayRetractableShort;
            this.showResult(this.dataset.copyTrayMismatch, this.dataset.copyTrayMismatch, copy, inputSummary);
            this.publish('completed', 'span_too_short', { thickness: thicknessInput, span: spanInput, model, mount });
            return;
          }
          if (model === 'compare' && !fixedEligible && !retractableEligible) {
            this.showResult(
              this.dataset.copyTrayMismatch,
              this.dataset.copyTrayMismatch,
              this.dataset.copyTrayFixedShort,
              inputSummary
            );
            this.publish('completed', 'span_too_short', { thickness: thicknessInput, span: spanInput, model, mount });
            return;
          }

          let resultCopy = '';
          let resultCode = '';
          if (model === 'fixed' || (model === 'compare' && fixedEligible && !retractableEligible)) {
            this.showChoice('fixed');
            resultCopy = this.dataset.copyTrayFixedMatch;
            resultCode = 'fixed_match';
          } else if (model === 'retractable') {
            this.showChoice('retractable');
            resultCopy = this.dataset.copyTrayRetractableMatch;
            resultCode = 'retractable_match';
          } else {
            this.showChoice('fixed');
            this.showChoice('retractable');
            resultCopy = this.dataset.copyTrayBothMatch;
            resultCode = 'both_match';
          }
          if (span > 74 + tolerance && model !== 'fixed') {
            resultCopy = `${resultCopy} ${this.dataset.copyTrayOverMax}`;
          }

          let resultStatus = boundary ? this.dataset.copyTrayLimit : this.dataset.copyTrayPotential;
          if (boundary) resultCopy = `${resultCopy} ${this.dataset.copyTrayBoundary}`;
          if (mount !== 'clear') {
            resultStatus = this.dataset.copyTrayManual;
            resultCopy = `${resultCopy} ${this.dataset.copyTrayObstruction}`;
            resultCode = 'manual_check';
          }
          this.showResult(resultStatus, resultStatus, resultCopy, inputSummary);
          this.publish('completed', resultCode, { thickness: thicknessInput, span: spanInput, model, mount });
        }

        applyChoice(event) {
          const form = event.currentTarget;
          const button = form.querySelector('[data-fit-option-value-id]');
          const picker = document.querySelector(
            `main[data-template^="product"] variant-picker[ref="mainVariantPicker"][data-block-id="${CSS.escape(
              this.dataset.pickerBlockId || ''
            )}"][data-product-id="${this.dataset.productId}"]`
          );
          const VariantPicker = customElements.get('variant-picker');
          if (
            !(button instanceof HTMLButtonElement) ||
            !(picker instanceof HTMLElement) ||
            typeof VariantPicker !== 'function' ||
            !(picker instanceof VariantPicker)
          ) {
            return;
          }
          const optionValueId = button.dataset.fitOptionValueId;
          const control = picker.querySelector(`[data-option-value-id="${CSS.escape(optionValueId || '')}"]`);
          if (!(control instanceof HTMLInputElement || control instanceof HTMLOptionElement)) return;
          event.preventDefault();

          if (this.pendingApply) return;
          if (control instanceof HTMLInputElement && control.checked) {
            this.announceSelection(button);
            return;
          }
          if (control instanceof HTMLOptionElement && control.selected) {
            this.announceSelection(button);
            return;
          }

          this.pendingApply = button;
          button.disabled = true;
          button.setAttribute('aria-busy', 'true');
          let selectEventSeen = false;
          const fallback = () => {
            const url = new URL(form.action, window.location.origin);
            url.searchParams.set('variant', button.value);
            window.location.assign(url);
          };
          const finish = () => {
            document.removeEventListener('shopify:product:select', onSelect);
            button.disabled = false;
            button.removeAttribute('aria-busy');
            if (this.pendingApply === button) this.pendingApply = null;
          };
          const isExpectedVariant = (result) => {
            const expectedId = String(button.dataset.fitVariantId || '');
            const resultIds = [result?.detail?.resource?.id, result?.variant?.id]
              .filter((id) => id != null)
              .map((id) => String(id));
            return resultIds.some((id) => id === expectedId || id.endsWith(`/${expectedId}`));
          };
          const onSelect = (selectEvent) => {
            if (selectEvent.target !== picker) return;
            selectEventSeen = true;
            document.removeEventListener('shopify:product:select', onSelect);
            const promise = selectEvent.promise;
            if (promise && typeof promise.then === 'function') {
              promise.then(
                (result) => {
                  finish();
                  if (isExpectedVariant(result)) {
                    this.announceSelection(button);
                  } else {
                    fallback();
                  }
                },
                (error) => {
                  finish();
                  if (error?.name !== 'AbortError') fallback();
                }
              );
            } else {
              finish();
              fallback();
            }
          };
          document.addEventListener('shopify:product:select', onSelect);

          if (control instanceof HTMLInputElement) {
            control.click();
          } else {
            const select = control.closest('select');
            if (!(select instanceof HTMLSelectElement)) {
              finish();
              return;
            }
            select.value = control.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
          if (!selectEventSeen) {
            finish();
            fallback();
          }
        }

        announceSelection(button) {
          const label = button.dataset.fitChoiceLabel || '';
          this.status.textContent = `${this.dataset.copySelected}: ${label}`;
          this.publish('applied', 'variant_selected', {
            variant_id: button.dataset.fitVariantId,
            option_value_id: button.dataset.fitOptionValueId
          });
        }

        publish(action, result, detail) {
          const publish = window.Shopify?.analytics?.publish;
          if (typeof publish !== 'function') return;
          const response = publish(`setup_supplies:fit_advisor_${action}`, {
            advisor_version: '1',
            advisor_type: this.dataset.advisorType,
            product_handle: this.dataset.productHandle,
            product_id: this.dataset.productId,
            unit: this.unit?.value || 'cm',
            result,
            ...detail
          });
          if (response && typeof response.catch === 'function') response.catch(() => {});
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
